// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingSpinner_root__nbOZ_"};